import { OptimizelyProviderWrapper } from '../optimizely';
import DefaultUpgradeModal from './DefaultUpgradeModal';
import ExperimentalUpgradeModal from './ExperimentalUpgradeModal';

const UpgradeModalWrapper = (props) => (
  <OptimizelyProviderWrapper
    defaultComponent={DefaultUpgradeModal}
    experimentalComponent={ExperimentalUpgradeModal}
    {...props}
  />
);

export default UpgradeModalWrapper;
